import { GetServerSideProps } from 'next';
import { useIntl } from 'react-intl';

import FamilyPlanLanding from '@/components/familyPlan/FamilyPlanLanding';
import Footer from '@/components/footer/FooterWrapper';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest } from '@/hooks/store';
import messages from '@/messages/messages';
import { isFamilyPricingAvailable } from '@/server/initState/getFamilyPrices';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const FamilyPlan = () => {
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="Family Plan Hub" title={`Calm - ${formatMessage(messages.familyPlanLandingTitle)}`}>
			<FamilyPlanLanding />
			<Footer />
		</Layout>
	);
};

export default FamilyPlan;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			plan: 'family',
		},
	);

	if (!isFamilyPricingAvailable(initialState?.prices)) {
		return {
			redirect: {
				destination: '/signup-flow',
				permanent: false,
			},
		};
	}

	return {
		props: {
			initialState,
		},
	};
};
